/**
 * The Back button in the panel footer (ExtensionAccountBar). A screen past the panel's first one
 * (the job wizard after "Send to mot-r") registers where Back goes; the footer shows the button
 * only while one is registered.
 */
import { useSyncExternalStore } from 'react';

type BackHandler = () => void;

let current: BackHandler | null = null;
const listeners = new Set<() => void>();

export const setExtensionBack = (onBack: BackHandler | null): void => {
  current = onBack;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export const useExtensionBack = (): BackHandler | null =>
  useSyncExternalStore(subscribe, () => current, () => null);
